import { createUseStyles } from 'react-jss';

export const useFormStyles = createUseStyles({
  form: {
    '& .ant-form-item': {
      marginBottom: 0,
    },
    '& .ant-typography': {
      marginBottom: 0,
    },
  },
  checkboxGroup: {
    '& .ant-checkbox-wrapper': {
      marginLeft: 0,
    },
  },
});
